(function() {
  angular.module("MktzapApp.Controllers")
    .controller("StatusController", status);

  status.$inject = ["FoundationApi", "StatusService", "CompanyService", "NotificationService","$state","$timeout","$rootScope","LocalStorageService"];

  function status(FoundationApi, StatusService, CompanyService, NotificationService, $state, $timeout, $rootScope,LocalStorageService)
  {
      if(LocalStorageService.checkInPause())
         LocalStorageService.sendToBlockPage();
      var vm = this;
      var selectedColor = "D2D2D2";
      vm.statuses = StatusService.query();
      vm.classification_statuses = StatusService.classification_statuses();
      StatusService.possible_parent_statuses()
      .$promise
      .then(function(data) {
          vm.parent_statuses = data.statuses;
      })
      .catch(function(error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadStatusConfig);
      });

      vm.openCreate = openCreate;
      vm.openEdit = openEdit;
      vm.confirmDelete = confirmDelete;
      vm.removeStatus = removeStatus;
      vm.changePosition = changePosition;
      vm.save = save;
      vm.checkSector = checkSector;
      vm.cancel = cancel;
      vm.polls = $rootScope.polls;
      vm.sending = false;

      StatusService.getConfigs()
      .$promise
      .then(function(data) {
          vm.colors = data.colors;
          vm.classificationLabel = data.classification;
          vm.flags = data.flags;
      })
      .catch(function(error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadStatusConfig);
      });

    CompanyService
      .allSectors()
      .$promise
      .then(function (data) {
        vm.sectors = data
      })
      .catch(function (data) {
        NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
      })

    function openCreate () {
      vm.sending = false
      vm.old = vm.status = {
        should_close: 0,
        should_require: 1,
        color: selectedColor
      }
      vm.possible_parents = vm.parent_statuses
      FoundationApi.publish("statusCreateModal", "open")
    }

  function openEdit (status) {
    vm.sending = false;
    vm.old = status;
    vm.status = status;
    vm.exclusive_sectors = status.sectors != null;
    removeStatusFromParents();
    FoundationApi.publish('statusEditModal', 'open');
  }

  function confirmDelete (status) {
    vm.deleting = status;
    FoundationApi.publish('statusConfirmDeleteModal', 'open');
  }

  function removeStatus (status) {
      vm.sending = true;
    StatusService
      .remove({ id: status.id })
      .$promise
      .then(function (data) {
        NotificationService.successHandler(data, $rootScope.labels.sucRemoveStatus);
        FoundationApi.publish('statusConfirmDeleteModal', 'close');
        if (parseInt(status.should_close) == 0) {
          $timeout(function () {
            vm.sending = false;
            $state.reload();
          }, 3000);
        } else { vm.statuses = StatusService.query(); }
      })
      .catch(function (e) {
        vm.sending = false;
        NotificationService.errorHandler(e, $rootScope.labels.errorRemoveStatus);
      });
  }

  function cancel () {
    vm.statuses = StatusService.query();
  }

  function save () {
    vm.sending = true;
    if (vm.old.id) {
      getSectors('');
      StatusService
        .update(vm.status)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.sucAlterStatus);
          FoundationApi.publish('statusEditModal', 'close');
          if (parseInt(vm.status.should_close) == 0) {
            $timeout(function () {
              vm.sending = false;
              $state.reload();
            }, 3000);
          } else { vm.statuses = StatusService.query(); }
        })
        .catch(function (e) {
          vm.sending = false;
          NotificationService.errorHandler(e, $rootScope.labels.errorUpdateStatus);
        });
    } else {
      getSectors('insert_');
      if (vm.status.should_close == 0) { vm.status.poll_id = null; }
      StatusService
        .save(vm.status)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.sucCreateStatus);
          FoundationApi.publish('statusCreateModal', 'close');
          if (parseInt(vm.status.should_close) == 0) {
            $timeout(function () {
              vm.sending = false;
              $state.reload();
            }, 3000);
          } else { vm.statuses = StatusService.query(); }
        })
        .catch(function (e) {
          vm.sending = false;
          NotificationService.errorHandler(e, $rootScope.labels.errorCreateStatus);
        });
    }
  }

  vm.checkBitwise = function (check, value) {
    return check & value;
  }

  function getSectors (insert) {
    vm.status.sectors = null;
    if (vm.exclusive_sectors) {
      var sectors = document.getElementsByName(insert + 'sectors');
      if (sectors.length > 0) {
        var sectorsArr = [];
        for (var i = 0; i < sectors.length; i++) {
          if (sectors[i].checked) { sectorsArr.push(sectors[i].id.replace(insert, '')); }
        }
        vm.status.sectors = (sectorsArr.length) ? (sectorsArr.join(',')) : (null);
      }
    }
  }

  function checkSector (insert, sector_id) {
    var sectorNull = document.getElementById(insert + '-1');

    if (sector_id == -1) {
      var sectors = document.getElementsByName(insert + 'sectors');
      if (sectors.length > 0) {
        for (var i = 0; i < sectors.length; i++) {
          if ((sectors[i].checked) && (sectors[i].id.replace(insert, '') != -1)) { sectors[i].checked = false; }
        }
      }
    } else {
      if (sectorNull.checked) { sectorNull.checked = false; }
    }
  }

  function changePosition (status, element, value) {
    var value = document.getElementById(element).value;
    StatusService
      .change_position({
        statusId: status.id,
        value: value
      })
      .$promise
      .then(function (data) {
        NotificationService.successHandler(data, $rootScope.labels.sucAlterStatus);
        vm.statuses = StatusService.query();
        $rootScope.classification_statuses = StatusService.menu_statuses();
      })
      .catch(function (e) {
        NotificationService.errorHandler(e, $rootScope.labels.errorCreateStatus);
      });
  }

  function removeStatusFromParents () {
    vm.possible_parents = new Array();
    angular.forEach(vm.parent_statuses, function (status) {
      if (vm.status.id != status.id) { vm.possible_parents.push(status); }
    });
  }
}
})();
